import React, { useState, useEffect } from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import "./Equipe.css";
import bgEquipe from "../assets/hero/equipebg.jpg"; 

const membros = [
  {
    nome: "Ricardo Rocha (Mr.Saizen)",
    cargo: "Fundador e treinador",
    area: "Musculação",
    foto: "/assets/equipe/ricardo.png",
    bio: "Operações Especiais Veterano do United States Army, Especialista em treinos de força, Bodybuilding, Coach, possui diversos atletas pro e em 2024 uma delas, A Isabela Pereira, se consagrou Miss Olympia na categoria categoria Women's Wellness.",
    instagram: "https://www.instagram.com/mrsaizen",
  },
  {
    nome: "Renan Almeida",
    cargo: "Fundador e Instrutor",
    area: "Treinamento operacional",
    foto: "/assets/equipe/renans.jpg",
    bio: "Militar, graduado em Direito e possui Especialização Operacional em Guerra na Selva, Operações Especiais e Ações Táticas Especiais. Após um grave acidente veicular de serviço, que quase incapacitou o movimento de seus dois braços, aplicou a metodologia de treinamento físico e mental que possibilitou que se formasse em 3 dos Cursos mais difíceis do Brasil, sendo agraciado com as honrarias de Aluno Destaque e 1° Colocado.",
    instagram: "https://www.instagram.com/renanoalmeida",
  },
  {
    nome: "William Muniz de Andrade",
    cargo: "Quiropraxista",
    area: "Quiropraxia",
    foto: "/assets/equipe/will.jpg",
    bio: "Bodybuilder, fisioterapeuta e quiropraxista, especialista em prevenir e tratar lesões da musculação. Une experiência prática e conhecimento científico para ajudar atletas a treinarem com mais segurança e desempenho.",
    instagram: "https://www.instagram.com/willl.andrade",
  }
];

export default function Equipe() {
  const [selecionado, setSelecionado] = useState(null);

  // Fecha modal com ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setSelecionado(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Bloqueia scroll do body quando modal aberto
  useEffect(() => {
    document.body.style.overflow = selecionado ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selecionado]);

  // Abre modal e joga scroll ao topo
  const abrirModal = (membro) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setSelecionado(membro);
  };

  return (
    <>
      <Header2 />

      <main className="team">
        {/* HERO */}
        {/* <section
          className="team-hero"
          style={{ backgroundImage: `url(${bgEquipe})` }}
        >
          <div className="team-hero__overlay" />
          <div className="team-hero__content container">
            <h1 className="accent">EQUIPE</h1>
            <p className="team-hero__subtitle">
              Conheça nossa equipe, formada por profissionais de alto nível.
            </p>
          </div>
        </section> */}
        <section className="hero team-hero">
        {/* Fundo com parallax — usa a mesma imagem que você importou */}
        <img
          className="hero__bg hero__bg--photo"
          src={bgEquipe}
          alt=""
          aria-hidden="true"
          data-depth="0.07"   // sensibilidade ao mouse (0.00–0.5)
          data-sdepth="0.20"  // sensibilidade ao scroll (0.00–0.5)
          data-max="26"       // deslocamento máx em px pelo mouse
        />

        {/* Overlay/gradiente acima do fundo, abaixo do conteúdo */}
        <div className="team-hero__overlay" />

        {/* Conteúdo do hero (fica por cima) */}
        <div className="team-hero__content container">
          <h1 className="accent">EQUIPE</h1>
          <p className="team-hero__subtitle">
            Conheça nossa equipe, formada por profissionais de alto nível.
          </p>
        </div>
      </section>

        {/* GRID */}
        <section
          className="team-grid container"
          aria-label="Lista de membros da equipe"
        >
          {membros.map((m, i) => (
            <article key={i} className="team-card">
              <button
                className="team-card__media"
                onClick={() => abrirModal(m)}
                aria-label={`Abrir bio de ${m.nome}`}
              >
                <img
                  src={m.foto}
                  alt={`${m.nome} — ${m.cargo}`}
                  loading="lazy"
                />
              </button>

              <div className="team-card__body">
                <div className="team-card__head">
                  <h3 className="team-card__name">{m.nome}</h3>
                  <span className="badge">{m.area}</span>
                </div>
                <p className="team-card__role">{m.cargo}</p>

                <div className="team-card__actions">
                  <a
                    href={m.instagram}
                    aria-label={`Instagram de ${m.nome}`}
                    className="icon-link"
                    onClick={(e) => !m.instagram && e.preventDefault()}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fill="currentColor"
                        d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5-5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3-3 0 0 0-3-3H7Zm5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2.2A2.8 2.8 0 1 0 12 15.8 2.8 2.8 0 0 0 12 9.2ZM18 7.2a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z"
                      />
                    </svg>
                  </a>
                  <button
                    className="btn btn--ghost"
                    onClick={() => abrirModal(m)}
                  >
                    Ver bio
                  </button>
                </div>
              </div>
            </article>
          ))}
        </section>
      </main>

      {/* MODAL */}
      {selecionado && (
        <div
          className="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
        >
          <div
            className="modal__backdrop"
            onClick={() => setSelecionado(null)}
          />
          <div className="modal__card">
            <button
              className="modal__close"
              onClick={() => setSelecionado(null)}
              aria-label="Fechar bio"
            >
              ×
            </button>
            <div className="modal__grid">
              <div className="modal__media">
                <img
                  src={selecionado.foto}
                  alt={`${selecionado.nome} — ${selecionado.cargo}`}
                />
              </div>
              <div className="modal__content">
                <h3 id="modal-title" className="modal__name">
                  {selecionado.nome}
                </h3>
                <p className="modal__role">
                  {selecionado.cargo} ·{" "}
                  <span className="badge">{selecionado.area}</span>
                </p>
                <p className="modal__bio">{selecionado.bio}</p>
                <div className="modal__actions">
                  {selecionado.instagram && (
                    <a
                      className="btn btn--ghost"
                      href={selecionado.instagram}
                    >
                      Instagram
                    </a>
                  )}
                  {selecionado.linkedin && (
                    <a
                      className="btn btn--primary"
                      href={selecionado.linkedin}
                    >
                      LinkedIn
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}
